import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from './axiosInstance';

export function api<T>(config: AxiosRequestConfig): Promise<T> {
  return axiosInstance.request(config).then((response) => response.data);
}
